import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'
import { Tooltip, calculateContractlength, allConfirmsChecked, getContractStartDate, getPersonAgeByContractDate, ssnIsUSABorn } from '../../utils'
import CurrencyFormat from 'react-currency-format';
import StartDateOptions from '../start-date-options'
import InsuranceTaker from '../insurance-taker'
import KomfortDynamicGuaranteedCapitalForm from "../komfort-dynamik-guaranteed-capital-form";

const kennitala = require('kennitala')

class LebenForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                age: '',
                ageContractEnd: '',
                payment: '',
                deathbenefits: '',
                lifeinsurance: '',
            }
        }

        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.validateForm = this.validateForm.bind(this)
        this.age = React.createRef()
        this.ageContractEnd = React.createRef()
        this.payment = React.createRef()
        this.deathbenefits = React.createRef()
        this.lifeinsurance = React.createRef()
        this.lebType = React.createRef()
        this.lebUnits = React.createRef()
    }

    componentDidMount () {
        if (this.props.initialValues['LEBcontractstartdate'] === undefined) {
            this.props.dispatch(setInfoKey({key: "LEBcontractstartdate", value: getContractStartDate("LEB").format("D.M.YYYY")}, this.props.customerId))
        }
        
        let info = kennitala.info(this.props.customerId)
        if (info.age > 17) {
            this.props.dispatch(setInfoKey({key: "LEBinsuranceTaker", value: this.props.customerId}, this.props.customerId))
        }
        const isUSABorn = ssnIsUSABorn(this.props.customerId, this.props); 
        if (isUSABorn) {
            this.props.dispatch(setInfoKey({key: "LEBPortfolio", value: 'perspektive'}, this.props.customerId))
        }

    }

    validateForm() {
        let errors = this.state.errors
        let valid = true;
        Object.keys(errors).forEach(key => {
            switch (key) {
                case 'age':
                    let ageValue = this.props.initialValues["age"];
                    if (parseInt(ageValue) < 18) {
                        errors.age = 'Að lágmarki 18'
                        valid = false;
                    } else if (parseInt(ageValue) > 80) {
                        errors.age = 'Að hámarki 80'
                        valid = false;
                    } else {
                        errors.age = ''
                    }
                    break;
                case 'ageContractEnd':
                    let ageContractEndValue = this.ageContractEnd.current.value;

                    let contractLength = calculateContractlength(this.props.customerId, ageContractEndValue, this.props.initialValues["LEBcontractstartdate"])

                    let minContractLength = 5;
                    if (this.props.initialValues["LEBPortfolio"].toLowerCase() === "komfortdynamik") {
                        minContractLength = 10;
                    }

                    if (contractLength < minContractLength && parseInt(ageContractEndValue) > 0) {
                        errors.ageContractEnd = `Samningur að lágmarki ${minContractLength} ár`
                        valid = false;
                    } else if (ageContractEndValue > 85) {
                        errors.ageContractEnd = 'Að hámarki 85'
                        valid = false;
                    }
                    else if (ageContractEndValue === '') {
                        errors.ageContractEnd = 'Skilyrði að fylla út'
                        valid = false;
                    }
                    else {
                        errors.ageContractEnd = ''
                    }
                    break;

                case 'payment':
                    let paymentValue = this.payment.current.state.numAsString;
                    if (paymentValue === '') {
                        errors.payment = 'Skilyrði að fylla út';
                        valid = false
                    } else {
                        errors.payment = ''
                    }
                    break;

                case 'deathbenefits':
                    if (this.props.initialValues["LEBdeathbenefits"] === true) {
                        let deathbenefitsValue = this.deathbenefits.current.state.numAsString;
                        let units = this.lebUnits.current.value
                        let lebType = this.lebType.current.value

                        if (units === 'percentage') {
                            if (parseInt(deathbenefitsValue) < 100) {
                                errors.deathbenefits = 'Að lágmarki 100%';
                                valid = false
                            } else if (deathbenefitsValue === '') {
                                errors.deathbenefits = 'Skilyrði að fylla út';
                                valid = false
                            } else {
                                errors.deathbenefits = ''
                            }
                        } else  {
                            if (lebType === 'insuranceamount' && parseInt(deathbenefitsValue) < parseInt(this.payment.current.state.numAsString)) {
                                errors.deathbenefits = 'Dánarbætur verða að vera >= tryggður höfuðstóll';
                                valid = false
                            }
                            else if (deathbenefitsValue === '') {
                                errors.deathbenefits = 'Skilyrði að fylla út';
                                valid = false
                            } else {
                                errors.deathbenefits = ''
                            }
                        }
                    } else {
                        errors.deathbenefits = ''
                    }
                    break;

                case 'lifeinsurance':
                    let lifeinsuranceValue = this.lifeinsurance.current.state.numAsString;
                    let units = this.lebUnits.current.value
                    if (units === 'percentage') {
                        if (parseInt(lifeinsuranceValue) < 100) {
                            errors.lifeinsurance = 'Að lágmarki 100%';
                            valid = false
                        } else if (parseInt(lifeinsuranceValue) > 400) {
                            errors.lifeinsurance = 'Að hámarki 400%';
                            valid = false
                        } else if (lifeinsuranceValue === '') {
                            errors.lifeinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.lifeinsurance = ''
                        }
                    } else  {
                        if (lifeinsuranceValue === '') {
                            errors.lifeinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.lifeinsurance = ''
                        }
                    }
                    break;
                case 'insurancetaker':
                    let insuranceTakerValue = this.props.initialValues['LEBinsuranceTaker'];
                    if (insuranceTakerValue === undefined || insuranceTakerValue === "") {
                        errors.insurancetaker = 'Velja þarf tryggingartaka'
                        valid = false;
                    } else {
                        errors.insurancetaker = ''
                    }
                    break;
                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.checked }, this.props.customerId))
    }

    onChangeTextInput(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeLargeNumberInput(value, name) {
        this.props.dispatch(setInfoKey({ key: name, value: value }, this.props.customerId))
    }

    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
        if(event.target.name === 'LEBPortfolio' && event.target.value === 'komfortdynamik') {
            // this.props.dispatch(setInfoKey({ key: 'LEBunits', value: 'percentage' }, this.props.customerId))
            this.props.dispatch(setInfoKey({ key: 'LEBtype', value: 'installments' }, this.props.customerId))
        }
    }
    onClickConfirm(event) {
        let validate = this.validateForm()

        if (this.props.isAdult && this.props.initialValues['LEBinsuranceTaker'] === undefined) {
            this.props.dispatch(setInfoKey({ key: 'LEBinsuranceTaker', value: this.props.customerId }, this.props.customerId))
        }

        if (validate) {
            Promise.resolve(this.props.dispatch(setInfoKey({ key: event.target.name, value: true }, this.props.customerId)))
                .then(() => {
                    this.props.onSuccess()
                })
        }
    }
    onClickChange(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    getPortfolioSelector(customerId, initialValues){
        let arr = ['KomfortDynamik', 'Perspektive']
        const isUSABorn = ssnIsUSABorn(this.props.customerId, this.props); 
        const defaultvalue = (isUSABorn ?  'Perspektive' : initialValues["LEBPortfolio"]).toLowerCase();
        return (
            <>   
            <select className="custom-select col-12 col-sm-6" id={`leb-portfolio-${customerId}`} name="LEBPortfolio" onChange={this.onChangeSelectValue} value={defaultvalue} disabled={initialValues.lebConfirm} >
                { arr.map((val) => {
                    let disabled = false
                    if (val === 'KomfortDynamik') {
                        if (!window.KOMFORT_DYNAMIK_ENABLED || isUSABorn) {
                            disabled = true
                        }
                    }
                    return <option key={val} value={val.toLowerCase()} disabled={disabled}>{val}</option>
                })}
            </select>
            {isUSABorn
            ?
                <Tooltip placement="bottom" text={"Samkvæmt upplýsingum úr Þjóðskrá er tryggingartaki fæddur í Bandaríkjunum. Ekki er hægt að velja ávöxtunarleiðina KomfortDynamik. Nánari upplýsingar eru á innri.allianz.is."} />
            :
                <></>
            }
            </>
        )   
    }

    render() {
        const { customerId, customers, active, initialValues } = this.props
        const contractAge = getPersonAgeByContractDate(customerId, initialValues["LEBcontractstartdate"])
        const displayAge = contractAge !== null ? contractAge : initialValues["age"]

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.age.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`leb-contract-age-${customerId}`} className="col-sm-8 col-form-label">
                            Samningsaldur
                            {this.state.errors.age.length > 0 ?
                                 <span className="error"> ({this.state.errors.age}) </span> : ''
                            }
                            <Tooltip placement="bottom" text={"Samningsaldur umsækjanda miðast við upphafsdag samnings.  Ef <strong>meira en 183 dagar</strong> eru liðnir frá síðasta afmæli á upphafsdegi er aldurinn námundaður upp um eitt ár."} />
                        </label>
                        <div className="col-sm-4">
                            <input id={`leb-contract-age-${customerId}`} name="contract-age" type="number" className="form-control px-2 text-sm-right" value={initialValues["age"]} disabled />
                            <input type="hidden" ref={this.age} id={`leb-age-${customerId}`} name="age" className="form-control px-2 text-sm-right" value={displayAge} />
                        </div>
                    </div>
                    <div className={`form-row align-items-center`}>
                        <label className="col-sm-8 col-form-label">
                            Upphaf samnings
                        </label>
                        <div className="col-sm-4 text-right">
                            <StartDateOptions
                                startDate={getContractStartDate("LEB").format("D.M.YYYY")}
                                selectedDate={initialValues["LEBcontractstartdate"]}
                                contractDateKey={"LEBcontractstartdate"}
                                customerId={customerId}
                                disabled={initialValues.lebConfirm}
                                dispatch={this.props.dispatch}
                            />
                        </div>
                    </div>
                    <div className={`${this.state.errors.ageContractEnd.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`leb-age-by-contract-end-${customerId}`} className='col-sm-8 col-form-label'>
                            Aldur við lok samnings (ár)
                            {this.state.errors.ageContractEnd.length > 0 ?
                                 <span className="error"> ({this.state.errors.ageContractEnd}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4">
                            <input ref={this.ageContractEnd} id={`leb-age-by-contract-end-${customerId}`} name="LEBageByContractEnd" type="number" className="form-control text-sm-right px-2" onChange={this.onChangeTextInput} value={initialValues["LEBageByContractEnd"]} disabled={initialValues.lebConfirm} />
                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <div className="col-sm-6">
                            <label htmlFor={`leb-portfolio-${customerId}`} className="col-sm-8 col-form-label">Ávöxtunarleið</label>
                        </div>
                        <div className="col-sm-6 text-right">
                            { this.getPortfolioSelector(customerId, initialValues) }
                        </div>
                    </div>

                    <KomfortDynamicGuaranteedCapitalForm customerId={customerId} initialValues={initialValues} disabled={initialValues.lebConfirm} dispatch={this.props.dispatch} keyPrefix="LEB" />

                    <div className="form-row align-items-center">
                        <label htmlFor={`leb-contract-length-${customerId}`} className="col-sm-8 col-form-label">Lengd samnings (ár)</label>
                        <div className="col-sm-4">
                            <input id={`leb-contract-length-${customerId}`} type="number" className="form-control text-sm-right px-2" onChange={this.onChangeTextInput} value={calculateContractlength(customerId, initialValues["LEBageByContractEnd"], this.props.initialValues["LEBcontractstartdate"])} disabled />
                        </div>
                    </div>

                    <div className={`${this.state.errors.payment.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <div className="col-sm-6">
                            <select ref={this.lebType} className="custom-select  col-12 col-sm-8" id={`leb-type-${customerId}`} name="LEBtype" onChange={this.onChangeSelectValue} value={initialValues["LEBtype"]} disabled={initialValues.lebConfirm} >
                                <option value="installments">Iðgjald</option>
                                {initialValues["LEBPortfolio"] !== "komfortdynamik" && <option value="insuranceamount">Tryggður höfuðstóll</option>}
                            </select>
                            {this.state.errors.payment.length > 0 ?
                                <span className="error"> ({this.state.errors.payment}) </span> : ''
                            }
                        </div>

                        <div className="col-sm-6 col-12 text-right currency">
                            <CurrencyFormat
                                ref={this.payment}
                                thousandSeparator={"."}
                                id={`leb-payment-${customerId}`}
                                name="LEBpayment"
                                type="text"
                                className="form-control"
                                value={initialValues["LEBpayment"]}
                                disabled={initialValues.lebConfirm} 
                                decimalSeparator={','}
                                onValueChange={(values) => {
                                    const { value } = values;
                                    this.onChangeLargeNumberInput(value, "LEBpayment")
                                }}
                            />
                            {initialValues["LEBtype"] === "installments" && <div className="text-right"><small>Á hverju greiðslutímabili</small></div>}
                            
                        </div>
                    </div>


{/* 
                    <div className={`${this.state.errors.payment.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="leb-payment" className="col-sm-8 col-form-label">
                            Heildariðgjaldagreiðsla <small>á hverju greiðslubili</small>
                            {this.state.errors.payment.length > 0 ?
                                 <span className="error"> ({this.state.errors.payment}) </span> : ''
                            }
                        </label>
                        <div className='col-12 col-sm-4 currency'>
                            <CurrencyFormat 
                                ref={this.payment}
                                thousandSeparator={"."} 
                                id={`leb-payment-${customerId}`} 
                                name="LEBpayment" 
                                type="text" 
                                className="form-control text-sm-right pr-4"                                 
                                value={initialValues["LEBpayment"]} 
                                disabled={initialValues.lebConfirm} 
                                decimalSeparator={','} 
                                onValueChange={(values) => {
                                    const {value} = values;
                                    this.onChangeLargeNumberInput(value, "LEBpayment")
                                }}
                            />
                        </div>
                    </div> */}

                    <div className={`${this.state.errors.lifeinsurance.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`leb-life-insurance-${customerId}`} className="col-sm-8 col-form-label">
                            Líftrygging &nbsp;
                            
                            <select ref={this.lebUnits} className="custom-select col-4" id={`leb-units-${customerId}`} name="LEBunits" onChange={this.onChangeSelectValue} value={initialValues["LEBunits"]} disabled={initialValues.lebConfirm} >
                                <option value="percentage">Hlutfall</option>
                                <option value="currency">Tryggingafjárhæð</option>
                            </select>

                            {this.state.errors.lifeinsurance.length > 0 ?
                                <span className="error"> ({this.state.errors.lifeinsurance}) </span> : ''
                            }
                        </label>
                        <div className={`col-12 col-sm-4 ${initialValues["LEBunits"]}`}>

                            <CurrencyFormat
                                ref={this.lifeinsurance}
                                thousandSeparator={"."}
                                id={`leb-life-insurance-${customerId}`}
                                name="LEBlife-insurance"
                                type="text"
                                className="form-control"
                                value={initialValues["LEBlife-insurance"]}
                                disabled={initialValues.lebConfirm} 
                                decimalSeparator={','}
                                onValueChange={(values) => {
                                    const { value } = values;
                                    this.onChangeLargeNumberInput(value, "LEBlife-insurance")
                                }}
                            />
                            {initialValues["LEBunits"] === "percentage" ? <div className="text-right"><small>Hlutfall af iðgjaldasummu</small></div> : <div className="text-right"><small>Tryggingafjárhæð</small></div>}
                            
                            
                        </div>
                    </div>
                    
                    <div className={`${this.state.errors.deathbenefits.length > 0 ? 'error' : ''} form-row checkbox-row align-items-center`}>
                        <div className="col-8">
                            <div className="col-form-label"><label className="caption-label" htmlFor={`leb-deathbenefits-${customerId}`}>
                                Dánarbætur vegna slyss
                                {this.state.errors.deathbenefits.length > 0 ?
                                    <span className="error"> ({this.state.errors.deathbenefits}) </span> : ''
                                }
                            </label></div>
                            <input ref={this.deathbenefits} type="checkbox" id={`leb-deathbenefits-${customerId}`} name="LEBdeathbenefits" onChange={this.onChangeCheckbox} checked={initialValues["LEBdeathbenefits"]} disabled={initialValues.lebConfirm} />
                            <label htmlFor={`leb-deathbenefits-${customerId}`} className="col-sm-10 col-form-label"></label>
                        </div>
                        {initialValues["LEBdeathbenefits"] === true &&
                            <div className={`col-12 col-sm-4 ${initialValues["LEBunits"]}`}>
                                <CurrencyFormat
                                    ref={this.deathbenefits}
                                    thousandSeparator={"."}
                                    id={`leb-death-insurance-${customerId}`}
                                    name="LEBdeath-insurance"
                                    type="text"
                                    className="form-control"
                                    value={initialValues["LEBdeath-insurance"]}
                                    disabled={initialValues.lebConfirm} 
                                    decimalSeparator={','}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        this.onChangeLargeNumberInput(value, "LEBdeath-insurance")
                                    }}
                                />
                                { initialValues["LEBunits"] === "percentage" ?
                                    <>
                                        { initialValues.LEBPortfolio.toLowerCase() === "komfortdynamik" ?
                                            <div className="text-right"><small>Hlutfall af iðgjaldasummu</small></div> 
                                            :
                                            <div className="text-right"><small>Hlutfall af tryggðum höfuðstól</small></div> 
                                        }
                                    </>
                                    :
                                    <div className="text-right"><small>Tryggingafjárhæð</small></div>
                                }
                            </div>
                        }
                    </div>

                    <div className="form-row align-items-center">
                        <div className="col-sm-8">
                            <label htmlFor={`leb-payment-frequency-${customerId}`} className="col-sm-8 col-form-label pl-0">Greiðslutíðni</label>
                        </div>
                        <div className="col-sm-4 text-right">
                            <select className="custom-select col-sm-4" id={`leb-payment-frequency-${customerId}`} name="LEBpaymentfrequency" onChange={this.onChangeSelectValue} value={initialValues["LEBpaymentfrequency"]} disabled={initialValues.lebConfirm}>
                                <option value="monthly">Mánaðarlega</option>
                                <option value="quarterly">Ársfjórðungslega</option>
                                <option value="every6months">Hálfsárslega</option>
                                <option value="yearly">Árlega</option>
                               
                            </select>
                        </div>
                    </div>
                    <InsuranceTaker fieldName={`LEBinsuranceTaker`} customerId={customerId} customers={customers} initialValues={initialValues} disabled={initialValues.lebConfirm} />

                </form>
                
                <div className="col-12 text-right button-container">
                    {initialValues.lebConfirm ?
                        (<button className="btn btn-primary xs-m-10" name="lebConfirm" onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name="lebConfirm" onClick={this.onClickConfirm}> Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default LebenForm